import {
  IconArrowAutofitRight,
  IconAlignBoxRightBottom,
  IconChevronLeft,
  IconChevronRight,
  IconPlus,
  IconRefresh,
} from '@tabler/icons-react';
import { Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthorizationHeader, http } from '../config/http';
import Layouts from '../layouts/Layouts';
import { DinamicTitle } from '../utils/DinamicTitle';
import DetailSaldoKas from './DetailSaldoKas';
import TambahSaldoKAS from './TambahSaldoKAS';

export default function HistorySaldo() {
  DinamicTitle('Saldo KAS');
  const [history, setHistory] = useState([]);
  const [totalSaldo, setTotalSaldo] = useState(0);
  const [cabang, setCabang] = useState([]);

  const [saldoCabang, setSaldoCabang] = useState([]);
  const [loading, setLoading] = useState(false);

  // filter
  const [search, setSearch] = useState('');
  const [idCabang, setIdCabang] = useState('');
  const [tipe, setTipe] = useState('');

  const [submitTambahSaldo, setSubmitTambahSaldo] = useState(false);

  function submitTambahSaldoKas() {
    setSubmitTambahSaldo(true);
  }

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  // console.log('lastPage::: ', lastPage);

  useEffect(() => {
    async function getHistory() {
      setLoading(true);
      await http
        .get(`/history/saldo?page=${currentPage}&cabang=${idCabang}&tipe=${tipe}`, {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          // console.log('res::: ', res.data)
          setSaldoCabang(res.data.saldo_cabang);
          setTotalSaldo(res.data.total_saldo);
          setCurrentPage(res.data.current_page);
          setLastPage(res.data.last_page_url);
          // console.log('res.data.last_page_url::: ', res.data.last_page_url);
          setHistory(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
      setLoading(false);
    }
    getHistory();
  }, [idCabang, tipe, currentPage, navigate, submitTambahSaldo === true]);

  useEffect(() => {
    async function getSaldoCabang() {
      await http
        .get('/cabang', {
          headers: { Authorization: getAuthorizationHeader() },
        })
        .then((res) => {
          setCabang(res.data.data);
        })
        .catch((err) => {
          if (err.response === 'undefined') {
            return null;
          } else if (err.response.status === 401) {
            navigate('/login');
          }
        });
    }
    getSaldoCabang();
  }, [navigate]);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // TAMBAH SALDO
  let [isOpenTambahSaldo, setIsOpenTambahSaldo] = useState(false);

  function closeModalTambahSaldo() {
    setIsOpenTambahSaldo(false);
  }

  function openModalTambahSaldo() {
    setIsOpenTambahSaldo(true);
  }
  const [detailSaldoKas, setDetailSaldoKas] = useState([]);
  const [loadingSaldo, setLoadingSaldo] = useState(false);
  async function getDetailSaldoKAS(id) {
    setLoadingSaldo(true);
    await http
      .get(`/history/saldo/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then((res) => {
        setDetailSaldoKas(res.data.data);
        setIsOpen(true);
      })
      .catch((err) => {
        if (err.response === 'undefined') {
          return null;
        } else if (err.response.status === 401) {
          navigate('/login');
        }
      });
    setLoadingSaldo(false);
  }

  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <Layouts
      // title={'Saldo KAS'}
      compFilter={
        <div className="dropdown dropdown-left md:hidden ">
          <Tooltip title="Saldo">
            <button tabIndex={0} className="bg-amber-500 hover:bg-amber-600 p-2.5 text-white rounded-md shadow-sm transition-colors">
              <IconAlignBoxRightBottom size={22} />
            </button>
          </Tooltip>
          <div tabIndex={0} className="dropdown-content menu p-4 shadow-xl bg-white dark:bg-slate-800 border dark:border-slate-700/60 rounded-xl w-72 mt-2 z-50">
            <h1 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-3 pb-2 border-b border-slate-100 dark:border-slate-700/60">Saldo: <span className="text-emerald-600 dark:text-emerald-400">Rp {numberWithCommas(totalSaldo === undefined ? '0' : totalSaldo)}</span></h1>
            <div className="flex flex-col gap-3">
              {saldoCabang.map((cb) => (
                <div key={cb.id} className="bg-slate-50 dark:bg-slate-800/50 p-3 rounded-lg border border-slate-100 dark:border-slate-700/50">
                  <div className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1">{cb.cabang?.nama_cabang}</div>
                  <div className="text-base font-bold text-emerald-600 dark:text-emerald-400">
                    Rp {numberWithCommas(cb.saldo === undefined ? '0' : cb.saldo)}
                  </div>
                </div>
              ))}
              <div className="pt-2">
                <button
                  type="button"
                  onClick={openModalTambahSaldo}
                  className="w-full flex justify-center items-center py-2.5 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-lg gap-2 text-sm font-semibold shadow-sm transition-all"
                >
                  Setor / Tarik Tunai
                  <IconArrowAutofitRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>
      }
    >
      {loadingSaldo ? (
        <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20 opacity-75 flex flex-col items-center justify-center">
          <div className="w-12 h-12  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
        </div>
      ) : (
        <></>
      )}

      <div className="flex flex-col md:flex-row gap-3">
        <div className="hidden md:block w-full md:w-[320px] lg:w-[350px] shrink-0">
          <div className="bg-white dark:bg-slate-900 rounded-xl shadow-md border border-slate-200 dark:border-slate-800 p-5 sticky top-0">
            <div className="flex items-start justify-between mb-5">
              <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mb-1">Total Saldo Keseluruhan</p>
                <h2 className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">Rp {numberWithCommas(totalSaldo === undefined ? '0' : totalSaldo)}</h2>
              </div>
              <Tooltip title="Refresh Data">
                <button onClick={() => window.location.reload()} className="p-2 bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-500 hover:bg-amber-100 dark:hover:bg-amber-800/30 rounded-lg transition-colors shadow-sm">
                  <IconRefresh size={20} />
                </button>
              </Tooltip>
            </div>

            <div className="space-y-3 mb-6 max-h-[50vh] overflow-y-auto scrollbar-thin pr-1">
              {saldoCabang.map((cb) => (
                <div key={cb.id} className="bg-amber-50/50 dark:bg-slate-800 p-3.5 rounded-lg border border-amber-100 dark:border-slate-700">
                  <div className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1.5">{cb.cabang?.nama_cabang}</div>
                  <div className="text-lg font-bold text-emerald-600 dark:text-emerald-500 tracking-wide">
                    Rp {numberWithCommas(cb.saldo === undefined ? '0' : cb.saldo)}
                  </div>
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={openModalTambahSaldo}
              className="w-full flex justify-center items-center py-3 bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 text-white rounded-lg gap-2 text-sm font-semibold shadow-md transition-all group"
            >
              <span>Setor / Tarik Tunai</span>
              <IconArrowAutofitRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>

        <div className="flex-1 w-full bg-white dark:bg-slate-900 rounded-xl shadow-md border border-slate-200 dark:border-slate-800 overflow-hidden min-h-[500px] flex flex-col">
          <div className="p-4 border-b border-slate-100 dark:border-slate-800 flex flex-wrap items-center gap-3 bg-slate-50/50 dark:bg-slate-900/50">
            <div className="w-full sm:w-auto">
              <input
                type="text"
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Cari Kode Faktur..."
                className="w-full sm:w-[220px] h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 focus:border-amber-500 focus:outline-none focus:ring-1 focus:ring-amber-500 rounded-lg transition-colors text-sm shadow-sm"
              />
            </div>
            <div className="flex-1 flex items-center gap-3">
              <select onChange={(e) => setIdCabang(e.target.value)} className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-lg cursor-pointer focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 transition-colors shadow-sm min-w-[140px]">
                <option value="">Semua Etalase</option>
                {cabang.map((cb) => (
                  <option key={cb.id} value={cb.id}>
                    {cb.nama_cabang}
                  </option>
                ))}
              </select>
              <select onChange={(e) => setTipe(e.target.value)} className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-lg cursor-pointer focus:outline-none focus:border-amber-500 focus:ring-1 focus:ring-amber-500 transition-colors shadow-sm min-w-[140px]">
                <option value="">Semua Tipe</option>
                <option value="Penjualan">Penjualan</option>
                <option value="Pembelian">Pembelian</option>
                <option value="Refund_Penjualan">Refund Penjualan</option>
                <option value="Refund_Pembelian">Refund Pembelian</option>
                <option value="Setor_Tunai">Setor Tunai</option>
                <option value="Tarik_Tunai">Tarik Tunai</option>
              </select>
            </div>
          </div>
          <DetailSaldoKas detailSaldoKas={detailSaldoKas} isOpen={isOpen} closeModal={closeModal} />
          <TambahSaldoKAS
            submitTambahSaldoKas={submitTambahSaldoKas}
            cabang={cabang}
            isOpenTambahSaldo={isOpenTambahSaldo}
            closeModalTambahSaldo={closeModalTambahSaldo}
          />
          {loading ? (
            <div className="flex-1 flex flex-col items-center justify-center min-h-[300px]">
              <div className="w-8 h-8 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent mb-3"></div>
              <span className="text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data histori...</span>
            </div>
          ) : (
            <div className="flex-1 overflow-x-auto overflow-y-auto scrollbar-thin rounded-b-xl border-t-0 border-slate-200 dark:border-slate-800">
              {history.length === 0 ? (
                <div className="flex items-center justify-center h-40 text-slate-500 dark:text-slate-400">Data Kosong...</div>
              ) : (

                <table className="w-full text-sm text-left align-middle border-collapse">
                  <thead className="text-xs text-amber-800 uppercase bg-gradient-to-r from-amber-50 to-amber-100/80 dark:bg-none dark:from-slate-800 dark:to-slate-800 dark:text-amber-400 border-b border-amber-200/50 dark:border-slate-700/60 sticky top-0 z-10">
                    <tr>
                      <th scope="col" className="px-4 py-3 border-r border-amber-200/30 dark:border-slate-700/50 whitespace-nowrap text-center">No</th>
                      <th scope="col" className="px-4 py-3 border-r border-amber-200/30 dark:border-slate-700/50 whitespace-nowrap">KODE FAKTUR</th>
                      <th scope="col" className="px-4 py-3 border-r border-amber-200/30 dark:border-slate-700/50 whitespace-nowrap text-right">Nominal</th>
                      <th scope="col" className="px-4 py-3 border-r border-amber-200/30 dark:border-slate-700/50 whitespace-nowrap text-right">Saldo Akhir</th>
                      <th scope="col" className="px-4 py-3 border-r border-amber-200/30 dark:border-slate-700/50 whitespace-nowrap">Tipe</th>
                      <th scope="col" className="px-4 py-3 border-r border-amber-200/30 dark:border-slate-700/50 whitespace-nowrap">Etalase</th>
                      <th scope="col" className="px-4 py-3 whitespace-nowrap">Tanggal</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white dark:bg-slate-900 divide-y divide-slate-100 dark:divide-slate-800/60">

                    {history
                      .filter((data) => data.kode_trx?.toLowerCase().includes(search.toLowerCase()))
                      .map((hs, i) => (
                        <tr
                          key={i}
                          onClick={() => getDetailSaldoKAS(hs.id)}
                          className="hover:bg-amber-50 dark:hover:bg-slate-800/80 cursor-pointer transition-colors"
                        >
                          <td className="px-4 py-3 whitespace-nowrap text-center text-slate-500 dark:text-slate-400">{i + 1}.</td>
                          <td className="px-4 py-3 whitespace-nowrap font-medium text-amber-600 dark:text-amber-500">{hs.kode_trx}</td>
                          <td className="px-4 py-3 whitespace-nowrap text-right font-semibold text-emerald-600 dark:text-emerald-400">
                            Rp {numberWithCommas(hs.saldo_awal === undefined ? '0' : hs.saldo_awal)}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-right font-medium text-slate-700 dark:text-slate-300">
                            Rp {numberWithCommas(hs.saldo_akhir === undefined ? '0' : hs.saldo_akhir)}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className="bg-amber-100 dark:bg-amber-900/30 text-amber-800 dark:text-amber-400 text-xs px-2 py-1 rounded-md font-medium">{hs.tipe}</span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-slate-600 dark:text-slate-300">{hs.cabang}</td>
                          <td className="px-4 py-3 whitespace-nowrap text-slate-500 dark:text-slate-400 text-xs">{hs.tanggal}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="bg-white bottom-0 flex justify-between left-0 py-4 w-full absolute">
        <div className="flex justify-end w-full mx-5">
          <div className="items-center flex justify-center space-y-2 text-sm sm:space-y-0 sm:space-x-4 sm:flex bg-white dark:bg-slate-900 py-1.5 px-3 rounded-lg border border-slate-200 dark:border-slate-800 shadow-sm">
            <span className="block text-slate-600 dark:text-slate-400">
              Halaman <span className="font-semibold text-amber-600 dark:text-amber-500">{currentPage}</span> dari <span className="font-semibold">{lastPage}</span>
            </span>
            <div className="space-x-1 border-l border-slate-200 dark:border-slate-700 pl-4">
              <button
                disabled={currentPage <= 1}
                onClick={() => setCurrentPage(currentPage - 1)}
                title="previous"
                type="button"
                className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
              >
                <IconChevronLeft size={18} />
              </button>
              <button
                disabled={currentPage >= lastPage}
                onClick={() => setCurrentPage(currentPage + 1)}
                title="next"
                type="button"
                className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
              >
                <IconChevronRight size={18} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layouts>
  );
}
